import React from 'react';
import styled from '@emotion/styled';
import moment from 'moment';
import { InternalLink, routes } from 'gatsby-theme-apollo';

const PostDate = styled.span`
  margin-top: 5px;
  text-align: center;
  color: ${props => props.theme.subtleText};
`;

const ByLineRoot = styled.div`
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const Author = styled.div({});

const ByLine = ({ author, date, canUpdate }) => {
  return (
    <ByLineRoot>
      {author && (
        <Author>
          <span>by{` `}</span>
          <InternalLink underline to={routes.User(author.name)}>
            {author.name}
          </InternalLink>
        </Author>
      )}
      {date && (
        <PostDate>
          {canUpdate && `Updated`} {moment(date).format('MMM YYYY')}
        </PostDate>
      )}
    </ByLineRoot>
  );
};

export default ByLine;
